import { SelectableProduct } from 'types/selectable-product';
import { useAppStore } from 'stores/appStore';
import { getSelectedProductIds } from 'utils/product-selection';

export function useProductSelection(maxSelectedProducts: number) {
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const setSelectedProducts = useAppStore((state) => state.setSelectedProducts);

  function toggleProduct(product: SelectableProduct) {
    if (selectedProducts.some((selectedProduct) => selectedProduct.id === product.id)) {
      setSelectedProducts(selectedProducts.filter((selectedProduct) => selectedProduct.id !== product.id));
      return;
    }

    if (selectedProducts.length >= maxSelectedProducts) {
      return;
    }

    setSelectedProducts([...selectedProducts, product]);
  }

  return {
    selectedProducts,
    selectedProductIds: getSelectedProductIds(selectedProducts),
    toggleProduct,
  };
}
